import { createContext } from 'react'

import { type AdminEmployer, type AdminEmployerProfile } from 'utils/web_api.schemas'

export type EmployerContextType = {
  employer?: AdminEmployer
  profile?: AdminEmployerProfile
}

const EmployerContext = createContext<EmployerContextType>({
  employer: undefined,
  profile: undefined,
})

export default EmployerContext
